export const getShortFormat = (number, locale, forceDigits) => {
    if (isNaN(parseInt(number, 10))) return number;
    if (typeof number === 'string') number = number.replace(',', '.');
    number = parseFloat(number);
    const isNegative = number < 0;
    number = Math.abs(number);

    let digits = 0;
    if (forceDigits) digits = forceDigits;
    else {
        if (number >= 1000 && number < 100000) {
            digits = 1;
        } else if (number >= 100000 && number < 1000000) {
            digits = 0;
        } else if (number >= 1000000 && number < 100000000) {
            digits = 1;
        } else if (number > 0 && number < 1) {
            digits = 2;
        }
    }

    const units = ['', 'K', 'M', 'B'];
    let decimal;

    let unitsIndex = 0;
    let finalValue = '';
    for (let i = units.length - 1; i >= 0; i--) {
        decimal = Math.pow(1000, i);

        if (number <= -decimal || number >= decimal) {
            unitsIndex = i;
            finalValue = truncate(number / decimal, digits);

            // 999500 will be 999.5k, but when rounded, it's 1000, so we need the next letter
            // similar thing happen in others ranges
            if (finalValue === '1000') {
                if (finalValue * decimal === 1000000) digits = 1;
                unitsIndex++;
                finalValue = truncate(finalValue / 1000, digits);
            } else if (finalValue === '100.0' && unitsIndex === 1) {
                if (finalValue * decimal === 100000000) digits = 0;
                finalValue = truncate(number / decimal, digits);
            }
            break;
        }
    }

    // 0 with decimals
    if ((number || number === 0) && !finalValue) finalValue = number;
    if (number !== 0 && (finalValue > 10e21 || finalValue < 10e-20) && !forceDigits) {
        finalValue = Number(finalValue).toPrecision(2);
    }

    if (isNegative) finalValue = parseFloat(finalValue) * -1;

    if (locale) {
        finalValue = getLocaleFormat(
            finalValue,
            locale,
            forceDigits ? { minimumFractionDigits: 2, maximumFractionDigits: digits } : undefined,
        );
    } else {
        finalValue = finalValue.toLocaleString(
            undefined,
            forceDigits ? { minimumFractionDigits: 2, maximumFractionDigits: digits } : undefined,
        );
    }

    return `${finalValue}${units[unitsIndex]}`;
};

export const truncate = (number, decimals) => {
    if (!number) return number;
    if (!decimals) return number;
    if (isNaN(number)) return number;

    const calcDec = Math.pow(10, decimals);
    return Math.trunc(number * calcDec) / calcDec;
};

export const getLocaleFormat = (number, locale, options) => {
    const defaultOptions = { useGrouping: true, minimumFractionDigits: 2, ...(options || {}) };
    return number.toLocaleString(locale, defaultOptions);
};

export const addNumberSeparators = (number, locale) => {
    if (!number) return '0';
    if (!locale) return number;
    return number.toLocaleString(locale);
};

export const getNumberAsLocaleNumber = (value, options) => {
    try {
        if (!value) return value;
        if (isNaN(value)) {
            value = value.replace(',', '.');
            if (isNaN(value)) return value;
        }
        options = { useGrouping: true, ...options };
        return Number(value).toLocaleString('en-US', options);
    } catch (ex) {
        console.warn('something wrong happens when formatting value ', value);
        // it's a minor issue, in case of an exception here, returning the value without format
        return value;
    }
};

// Returns true for locales with decimal comma and currency symbol at left
const isLocaleSpecialFormat = (locale) =>
    locale === 'en-US' || locale === 'en-GB' || locale === 'th-TH';

const getLocaleDecimalNumberFormat = (number, locale) => {
    if (number && !isNaN(number)) {
        number = number.toString();
        if (isLocaleSpecialFormat(locale)) {
            number = number.replace(',', '.');
        } else {
            number = number.replace('.', ',');
        }
        return number;
    }
    return number;
};

export const formatNumberWithSeparator = (number, locale) => {
    let parts;
    let formatedNumber;
    if (isLocaleSpecialFormat(locale)) {
        parts = number.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        formatedNumber = parts.join('.');
    } else {
        parts = number.toString().split(',');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        formatedNumber = parts.join(',');
    }
    return formatedNumber;
};

export const formatLargeNumber = ({ number, decimals = 2, locale }) => {
    if (isNaN(number)) return number;
    number = parseFloat(number);
    const isNegative = number < 0;
    number = Math.abs(number);

    const finalDecimals = decimals * 10;

    let digits = 0;
    if (number >= 1000 && number < 100000) {
        digits = 1;
    } else if (number >= 100000 && number < 1000000) {
        digits = 0;
    } else if (number >= 1000000 && number < 100000000) {
        digits = 1;
    }

    const units = ['', 'K', 'M', 'B'];
    let decimal;

    let unitsIndex = 0;

    let finalValue = '';
    for (let i = units.length - 1; i >= 0; i--) {
        decimal = Math.pow(1000, i);

        if (number <= -decimal || number >= decimal) {
            unitsIndex = i;
            finalValue = truncate(number / decimal, digits);

            // 999500 will be 999.5k, but when rounded, it's 1000, so we need the next letter
            // similar thing happen in others ranges
            if (finalValue === '1000') {
                if (finalValue * decimal === 1000000) digits = 1;
                unitsIndex++;
                finalValue = truncate(finalValue / 1000, digits);
            } else if (finalValue === '100.0' && unitsIndex === 1) {
                if (finalValue * decimal === 100000000) digits = 0;
                finalValue = truncate(number / decimal, digits);
            }
            break;
        }
    }
    if (finalValue > 10e21 || finalValue < 10e-20) {
        finalValue = Number(finalValue).toPrecision(2);
    }

    if (isNegative) finalValue = parseFloat(finalValue) * -1;
    finalValue = Math.round(finalValue * finalDecimals) / finalDecimals;
    finalValue = formatNumberWithSeparator(
        getLocaleDecimalNumberFormat(finalValue, locale),
        locale,
    );
    return finalValue + units[unitsIndex];
};
